import axios from 'axios'
import session from 'vue-cookies'
var url = "https://api.bertiebets.com/events"
var key = session.get('bertiebets.admin.key')
export async function getEvents() {
    var response = await axios.get(url, {headers:{'x-api-key' : key}})
    return response
}
